import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';

const TableHeader = ({ 
    globalFilterValue, 
    onGlobalFilterChange, 
    filters,
    onCategoryFilterChange,
    onDateFilterChange,
    categorias,
    onCreateNew,
    showOnlyActive,
    onToggleActiveFilter
}) => {
    return (
        <div className="flex justify-content-between align-items-center">
            <h3 className="m-0">
                <Button 
                    label="Crear Proveedor" 
                    icon="pi pi-plus" 
                    onClick={onCreateNew} 
                />
            </h3>
            <div className="flex gap-2">
                <span className="p-input-icon-left">
                    <InputText 
                        value={globalFilterValue} 
                        onChange={onGlobalFilterChange} 
                        placeholder="Buscar..." 
                        icon="pi pi-search"
                    />
                </span>
                <Dropdown 
                    value={filters.CATEGORIA.value} 
                    options={categorias}
                    onChange={onCategoryFilterChange}
                    placeholder="Filtrar por categoría"
                    showClear
                    optionLabel='name'
                    optionValue='name'
                />
                {/* <Calendar 
                    value={filters.ULTIMA_COMPRA_FECHA.value}
                    onChange={onDateFilterChange}
                    placeholder="Filtrar por fecha"
                    showIcon
                    showButtonBar
                /> */}
                <div className="flex align-items-center gap-2">
                    <Checkbox 
                        inputId="showActive" 
                        checked={showOnlyActive} 
                        onChange={onToggleActiveFilter}
                    />
                    <label htmlFor="showActive" className="cursor-pointer">Solo Activos</label>
                </div>
            </div>
        </div>
    );
};

export default TableHeader;
